// extracted by mini-css-extract-plugin
module.exports = {"root":"Heading_root__2lznU","heading":"Heading_heading__JHbIG","title":"Heading_title__3l0Of","subContainer":"Heading_subContainer__kw6eV","subHeading":"Heading_subHeading__Bz2Nn"};